import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import localeDeCh from '@angular/common/locales/de-CH';
import { LOCALE_ID, Provider } from '@angular/core';

/**
 * The app speaks Swiss German (Tester-Feedback Runde 1, Punkt 10/11): the date pipe formats with German month and day
 * names and «| date» without format shows TT.MM.JJJJ (before: «Oct 12, 2026»). Technical formats with an explicit
 * locale (formatDate(…, 'yyyy-MM-dd', 'en'), Intl.DateTimeFormat('de-CH')) and the offline data are not affected.
 */
export const APP_LOCALE = 'de-CH';

registerLocaleData(localeDeCh, APP_LOCALE);

export const APP_LOCALE_PROVIDERS: Provider[] = [
  { provide: LOCALE_ID, useValue: APP_LOCALE },
  { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'dd.MM.yyyy' } },
];
